/**
 * 控制模块功能是否可见
 */
 const config: any = {
    // 打新日历新功能配置
    hitNewStock: {
        ths: {
            ios: '10.90.40',
            android: '10.42.01'
        },
        thspro: {
            ios: '10.90.40',
            android: '10.42.01'
        },
        ifind: {
            ios: '8.1.0',
            android: '8.1.0'
        }
    },
}
export default config;